module.exports = __webpack_public_path__ + "static/media/Vault.38cf0db9.png";